import React from 'react';
import { ContentLayout } from 'src/components/ContentLayout';
import { ApplicationDetails } from 'src/components/ApplicationDetails';

export const ApplicationPage = () => {
  return (
    <ContentLayout>
      <ApplicationDetails />
    </ContentLayout>
  );
};
